import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_UPDATE_ACCOUNT_DATA_BEGIN,
  MANAGE_SUBS_UPDATE_ACCOUNT_DATA_SUCCESS,
  MANAGE_SUBS_UPDATE_ACCOUNT_DATA_FAILURE,
  MANAGE_SUBS_UPDATE_ACCOUNT_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function updateAccountData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_UPDATE_ACCOUNT_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
     
      const doRequest = axios.post(`${API_REQUEST_URL}/updateManageAccountsData`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_UPDATE_ACCOUNT_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_UPDATE_ACCOUNT_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateAccountDataError() {
  return {
    type: MANAGE_SUBS_UPDATE_ACCOUNT_DATA_DISMISS_ERROR,
  };
}

export function useUpdateAccountData() {
  const dispatch = useDispatch();

  const { updateAccountDataPending, updateAccountDataError } = useSelector(
    state => ({
      updateAccountDataPending: state.manageSubs.updateAccountDataPending,
      updateAccountDataError: state.manageSubs.updateAccountDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(updateAccountData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUpdateAccountDataError());
  }, [dispatch]);

  return {
    updateAccountData: boundAction,
    updateAccountDataPending,
    updateAccountDataError,
    dismissUpdateAccountDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_UPDATE_ACCOUNT_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateAccountDataPending: true,
        updateAccountDataError: null,
      };

    case MANAGE_SUBS_UPDATE_ACCOUNT_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        updateAccountDataPending: false,
        updateAccountDataError: null,
      };

    case MANAGE_SUBS_UPDATE_ACCOUNT_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        updateAccountDataPending: false,
        updateAccountDataError: action.data.error,
      };

    case MANAGE_SUBS_UPDATE_ACCOUNT_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateAccountDataError: null,
      };

    default:
      return state;
  }
}
